import ApiService from './api';
import type { ApiResponse } from '~/types/api';

// Form gönderimi için tip tanımı
interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  department: string;
  subject?: string;
  message: string;
  file?: File | null;
  recaptchaToken?: string;
}

// Form cevabı için tip tanımı
interface ContactResponse {
  message: string;
  success: boolean;
}

/**
 * İletişim formu gönderimleri için API işlemleri
 */
export default class ContactService {
  private static instance: ContactService;
  private apiService: ApiService;
  private endpoint: string = '/contact';

  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  /**
   * Singleton örneği al
   */
  public static getInstance(): ContactService {
    if (!ContactService.instance) {
      ContactService.instance = new ContactService();
    }
    return ContactService.instance;
  }

  /**
   * İletişim formunu gönder
   * @param formData Form verileri
   * @param lang Dil kodu (örn: tr, en)
   */
  public async submitContactForm(formData: ContactFormData, lang: string = 'tr'): Promise<ApiResponse<ContactResponse>> {
    try {
      // MultipartFormData olarak gönderilecek
      const formDataObj = new FormData();
      formDataObj.append('name', formData.name);
      formDataObj.append('email', formData.email);

      if (formData.phone) {
        formDataObj.append('phone', formData.phone);
      }

      formDataObj.append('department', formData.department);

      if (formData.subject) {
        formDataObj.append('subject', formData.subject);
      }

      formDataObj.append('message', formData.message);
      formDataObj.append('lang', lang);

      if (formData.recaptchaToken) {
        formDataObj.append('recaptchaToken', formData.recaptchaToken);
      }

      if (formData.file) {
        formDataObj.append('attachment', formData.file);
      }

      // FormData nesnesi doğrudan gönderilemez, özel fetch kullanmalıyız
      const config = useRuntimeConfig()

      const response = await fetch(`${config.public.NUXT_PUBLIC_BACKEND_BASE_URL || 'http://localhost:8080'}${this.endpoint}`, {
        method: 'POST',
        body: formDataObj
      });

      const data = await response.json();
      return data as ApiResponse<ContactResponse>;
    } catch (error) {
      console.error('İletişim formu gönderilirken hata oluştu:', error);
      throw error;
    }
  }
} 